import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-XR9S7MTFS4";

export function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag) return;

        const page_path = location.pathname + location.search;

        window.gtag("event", "page_view", {
            page_path,
            page_location: window.location.href,
            page_title: document.title,
            send_to: GA_MEASUREMENT_ID,
        });
    }, [location]);
}